import { render, staticRenderFns } from "./Createquestion.vue?vue&type=template&id=6a3d6591&scoped=true"
import script from "./Createquestion.vue?vue&type=script&lang=js"
export * from "./Createquestion.vue?vue&type=script&lang=js"
import style0 from "./Createquestion.vue?vue&type=style&index=0&id=6a3d6591&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3d6591",
  null
  
)

export default component.exports